







































































































































import BaseFilter from '@/components/Filter/BaseFilter';
import { Component, PropSync} from 'vue-property-decorator';
import { PreprocessingRuleFilter } from '@/store/settings/preprocessing_rules/types';
import { SelectWings, ToggleWings, InputWings } from 'wings-ui-components';
import { Action, Getter } from 'vuex-class';
import { notifyError } from '@/utils/notify-helper';
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({ components: { SelectWings, ToggleWings, InputWings } })
export default class PreprocessingRulesFilter extends BaseFilter<PreprocessingRuleFilter> {
  @PropSync('show') is_show!: boolean;

  @Getter("transports") transportsList: any;
  @Getter("positionList") positionList: any;

  @Action("getPartners") actionGetPartners: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action("getPreprocessingRules") actionGetPreprocessingRules: any;

  partnersList: any = []
  originatorsList: any = []
  accountsList: any = []
  templatesList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators(filter);
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts(filter);
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getTemplatesList(filter: any) {
    if (!this.filter.channel) return;
    const items = await this.actionGetTemplates({transport: this.filter.channel, filter: {partner: this.filter.partner, ...filter}});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  async created() {
    try {
      this.actionGetTransports();
      this.filtered();
    } catch (error) {
      notifyError(error);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.originator) this.originatorsList = await this.actionGetOriginators({originator: this.filter.originator});
    if (this.filter.account) this.accountsList = await this.actionGetAccounts({login: this.filter.account});
    if (this.filter.template) this.templatesList = await this.actionGetTemplates({transport: this.filter?.channel, filter: {name: this.filter.template}});
  }

  defaultFilter(): PreprocessingRuleFilter {
    return {
      rule: undefined,
      position: undefined,
      partner: undefined,
      account: undefined,
      channel: undefined,
      originator: undefined,
      template: undefined,
    }
  }

  async onFilteredAction() {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Additional processing rule",
        addititional_info: getTranslatedParams(this.filter)
      }
      await this.actionGetPreprocessingRules(this.filter);
      await this.actionLog(this.logObject);
    } catch(error) {
      this.actionLog({...this.logObject, action_status: "failed"});
    }
  }
};
